import { InjectionToken, InputSignal } from '@angular/core';

/**
 * Interface for the DsListComponent, used for dependency injection.
 * Provides access to commonly used list properties from child components.
 */
export interface IDsListComponent {
    /** Size of the list items ('sm', 'md', 'lg', or null for default) */
    size: InputSignal<'sm' | 'md' | 'lg' | null>;

    /** Array of currently selected item values */
    selectedItems: InputSignal<string[]>;

    /** Whether multiple items can be selected simultaneously */
    multiple: InputSignal<boolean | undefined>;

    /** Whether selection is enabled for list items */
    select: InputSignal<boolean>;

    /** Whether list items are in tab order (true) or use arrow key navigation (false) */
    tabbable: InputSignal<boolean>;
}

/**
 * Injection token for providing the DsListComponent instance to child components.
 * Used by DsListItemComponent to access parent list configuration.
 */
export const DS_LIST_COMPONENT = new InjectionToken<IDsListComponent>('DsListComponent');
